import type { ConversationState } from "@ai-admin/shared";
import type { Tone } from "../../ui/index.js";

/** Цвет метки состояния диалога (общий для списка, переписки и карточки клиента). */
export const stateTone: Record<ConversationState, Tone> = { bot: "blue", escalated: "amber", staff: "green", paused: "slate" };
